import { useQuery } from '@tanstack/react-query';
import { getDataIntelInfo, getCanadaStats, getUSStats, getPipelineStatus, getFunderOverview } from '../services/dataintel';

export const useDataIntelInfo = () => useQuery({ queryKey: ['dataintel', 'info'], queryFn: getDataIntelInfo });
export const useCanadaStats = () => useQuery({ queryKey: ['dataintel', 'canada-stats'], queryFn: getCanadaStats });
export const useUSStats = () => useQuery({ queryKey: ['dataintel', 'us-stats'], queryFn: getUSStats });
export const usePipelineStatus = () => useQuery({ queryKey: ['dataintel', 'pipeline-status'], queryFn: getPipelineStatus });
export const useFunderOverview = () => useQuery({ queryKey: ['dataintel', 'funder-overview'], queryFn: getFunderOverview });
